import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, ListChecks, Layers } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function TrustMiniSection() {
  const {
    lang
  } = useLanguage();
  const cards = [{
    Icon: Rocket,
    iconBg: '#7C3AED',
    title: lang === 'es' ? 'Lanzas en días, no en meses' : 'Launch in days, not months',
    desc: lang === 'es' ? 'Sin burocracia, sin confusión. Te entregamos todo listo para operar.' : 'No bureaucracy, no confusion. We deliver everything ready to operate.'
  }, {
    Icon: ListChecks,
    iconBg: '#7C3AED',
    title: lang === 'es' ? 'Cada paso, claro y guiado' : 'Every step, clear and guided',
    desc: lang === 'es' ? 'Sabes exactamente qué sigue, qué necesitas y cuánto tiempo toma.' : 'You know exactly what comes next, what you need, and how long it takes.'
  }, {
    Icon: Layers,
    iconBg: '#7C3AED',
    title: lang === 'es' ? 'Tú eliges según tu etapa' : 'You choose based on your stage',
    desc: lang === 'es' ? '¿Solo la empresa? ¿Solo la web? ¿Todo junto? Tú decides cómo empezar.' : 'Just the company? Just the website? Everything together? You decide how to start.'
  }];
  return <section className="trust-section" style={{
    background: '#5a4579',
    padding: '80px 24px',
    position: 'relative',
    overflow: 'hidden'
  }} data-id="element-541">
      <style data-id="element-542">{`
        .trust-section { padding: 60px 20px 40px !important; }
        .trust-grid { gap: 12px; }
        .trust-card {
          flex-direction: row !important;
          align-items: center !important;
          gap: 14px !important;
          padding: 16px !important;
          min-height: 80px;
        }
        .trust-icon {
          width: 40px !important;
          height: 40px !important;
          min-width: 40px !important;
        }
        .trust-icon svg { width: 20px !important; height: 20px !important; }
        .trust-title { font-size: 16px !important; margin-bottom: 2px !important; }
        .trust-desc { font-size: 14px !important; line-height: 1.45 !important; }
        @media (min-width: 769px) {
          .trust-section { padding: 80px 24px !important; }
          .trust-grid { gap: 24px; }
          .trust-card {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 18px !important;
            padding: 32px 28px !important;
            min-height: 0;
          }
          .trust-icon {
            width: 52px !important;
            height: 52px !important;
            min-width: 52px !important;
          }
          .trust-icon svg { width: 24px !important; height: 24px !important; }
          .trust-title { font-size: 18px !important; margin-bottom: 8px !important; }
        }
      `}</style>

      {/* Decorative glow orbs */}
      <div aria-hidden="true" className="absolute pointer-events-none" style={{
      top: '-150px',
      right: '-120px',
      width: '420px',
      height: '420px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(124,58,237,0.35) 0%, rgba(124,58,237,0) 70%)'
    }} data-id="element-543" />
      <div aria-hidden="true" className="absolute pointer-events-none" style={{
      bottom: '-160px',
      left: '-120px',
      width: '380px',
      height: '380px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(167,139,250,0.18) 0%, rgba(167,139,250,0) 70%)'
    }} data-id="element-544" />

      <div className="max-w-6xl mx-auto relative" style={{
      zIndex: 1
    }} data-id="element-545">
        <div className="text-center mb-12 md:mb-14" data-id="element-546">
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[24px] md:text-[36px] mb-4 md:mb-0" style={{
          fontFamily: "'Playfair Display', serif",
          color: '#FFFFFF',
          fontWeight: 700,
          textAlign: 'center',
          lineHeight: 1.2
        }} data-id="element-547">
            {lang === 'es' ? 'Por qué Inkova es ' : 'Why Inkova is '}
            <span className="italic" style={{
            fontStyle: 'italic',
            fontWeight: 600,
            color: '#D8B4FE'
          }} data-id="element-548">
              {lang === 'es' ? 'diferente' : 'different'}
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="mx-auto" style={{
          color: '#C4B5FD',
          fontSize: '16px',
          textAlign: 'center',
          maxWidth: '520px',
          marginTop: '14px',
          lineHeight: 1.6
        }} data-id="element-549">
            {lang === 'es' ? 'Todo lo que necesitas para construir tu negocio digital, en un solo lugar.' : 'Everything you need to build your digital business, in one place.'}
          </motion.p>
        </div>

        <div className="trust-grid grid md:grid-cols-3 gap-3 md:gap-6" data-id="element-550">
          {cards.map(({
          Icon,
          iconBg,
          title,
          desc
        }, i) => <motion.div key={i} className="trust-card" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '18px',
          padding: '32px 28px',
          background: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(167,139,250,0.18)',
          borderLeft: '2px solid #A78BFA',
          borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          transition: 'all 0.3s ease'
        }} onMouseEnter={e => {
          const el = e.currentTarget as HTMLDivElement;
          el.style.borderColor = 'rgba(167,139,250,0.5)';
          el.style.boxShadow = '0 16px 48px rgba(124,58,237,0.3)';
          el.style.transform = 'translateY(-4px)';
        }} onMouseLeave={e => {
          const el = e.currentTarget as HTMLDivElement;
          el.style.borderColor = 'rgba(167,139,250,0.18)';
          el.style.borderLeftColor = '#A78BFA';
          el.style.boxShadow = '0 8px 32px rgba(0,0,0,0.18)';
          el.style.transform = 'translateY(0)';
        }} data-id="element-551">
              <div className="trust-icon flex items-center justify-center flex-shrink-0" style={{
            width: '52px',
            height: '52px',
            minWidth: '52px',
            background: iconBg,
            borderRadius: '50%',
            boxShadow: `0 8px 20px ${iconBg}55`
          }} data-id="element-552">
                <Icon color="#FFFFFF" size={24} strokeWidth={2} data-id="element-553" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-554">
                <h3 className="trust-title" style={{
              color: '#FFFFFF',
              fontSize: '18px',
              fontWeight: 700,
              marginBottom: '8px',
              lineHeight: 1.3
            }} data-id="element-555">
                  {title}
                </h3>
                <p className="trust-desc" style={{
              color: '#D8B4FE',
              fontSize: '14px',
              lineHeight: 1.6
            }} data-id="element-556">
                  {desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}